import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IAddressField, MultiFieldData } from '@shared/interfaces';

@Component({
  selector: 'app-section-address',
  templateUrl: './section-address.component.html',
  styleUrls: ['./section-address.component.scss'],
})
export class SectionAddressComponent {
  @Input() sectionName: IAddressField;
  @Input() value: any; // ✅ receive customer_name value from parent
  @Output() setValue = new EventEmitter<any>();

  onComplexFieldSetClicked(_form: MultiFieldData) {
    this.setValue.emit(_form.value); // ✅ emit only value
  }
}
